import React from "react";
import HeaderDropdown from "./HeaderDropdown/HeaderDropdown";
import MapDropdown from "./MapDropdown/MapDropdown";
import SaleDropdown from "./SaleDropdown/SaleDropdown";
import SortDropdown from "./SortDropdown/SortDropdown";

interface DropdownHeader {
  mode: "headerDropdown";
  title: string;
  content?: IContent[];
  extraContent?: IExtraContent[];
}
interface MapDropdown {
  mode: "mapDropdown";
  title: string;
  subtitle: string;
  setGeolocation: (v: string) => void;
  info: MapInfo[];
}
interface SaleDropdown {
  mode: "saleDropdown";
  number: number;
  title: string;
  text: string;
}
interface SortDropdown {
  mode: "sortDropdown";
}

interface IContent {
  id: number;
  text: string;
}
interface IExtraContent {
  id: number;
  extraTitle: string;
  content: IContent[];
}

interface Adress {
  id: number;
  text: string;
}
interface MapInfo {
  id: number;
  name: string;
  adress: Adress[];
}

type DropdownProps = DropdownHeader | MapDropdown | SaleDropdown | SortDropdown;

const Dropdown: React.FC<DropdownProps> = (props) => {
  const dropdownMode = props.mode;

  return (
    <>
      {dropdownMode === "headerDropdown" ? (
        <HeaderDropdown title={props.title} content={props.content} extraContent={props.extraContent} />
      ) : dropdownMode === "mapDropdown" ? (
        <MapDropdown title={props.title} subtitle={props.subtitle} setGeolocation={props.setGeolocation} info={props.info} />
      ) : dropdownMode === "saleDropdown" ? (
        <SaleDropdown number={props.number} title={props.title} text={props.text} />
      ) : dropdownMode === "sortDropdown" ? (
        <SortDropdown />
      ) : (
        ""
      )}
    </>
  );
};

export default Dropdown;
